<template>
  <div style="overflow:hidden;"  class="mainbox">
    <div class="leftbox">
      <div class="leftboxmain" id="leftboxmain">
        <div class="backlist" @click="$router.go(-1)">
            <span>
              <Icon type="ios-arrow-back" />返回列表
            </span>
          </div>
        <Anchor show-ink :offset-top="160" :scroll-offset="30">
          <AnchorLink href="#dqwz" :title="categorydatatitle.name" />
        </Anchor>
      </div>
    </div>
    <div class="rightbox">
      <div class="rightmainbox">
        
        <div class="fenleibiaoti">
          <h3>{{categorydatatitle.name}}</h3>
          <h2>{{categorydatatitle.remark}}</h2>
        </div>
        <div class="fenleimain">
          <div class="indexcell" id="b-word-baike">
            <table>
             
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li v-for="(item,index) in categorydatalist" :key="index">
                        <webcell :categorydata="item"></webcell>
                      </li>
                      
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
        </div>
      </div>
    </div>

    <div class="footerbox"></div>

    <div class="addwebbox">
      <addweb></addweb>
    </div>
    <BackTop :bottom="200" :right="25"></BackTop>
  </div>
</template>

<script>
import addweb from "../publish/addweb";
import webcell from "../publish/webcell";
// import { getlistByCategory } from "../../api/api";
export default {
  components: { addweb,webcell },
  data() {
    return {
      blogo01: require("@/assets/images/b-icon_001.jpg"),
      blogo02: require("@/assets/images/b-icon_002.jpg"),
      blogo03: require("@/assets/images/b-icon_003.jpg"),
      blogo04: require("@/assets/images/b-icon_004.jpg"),
      blogo05: require("@/assets/images/b-icon_005.jpg"),
      anlismlogo: require("@/assets/images/alsmlogo.gif"),
      categoryId:this.$route.query.id,
      categorydatatitle:{},
      categorydatalist:[]
    };
  },
  created(){    
    window.scrollTo(0,0);
    let categoryId = this.categoryId;
    getlistByCategory(categoryId).then(res=>{

        if(res.code==200){
          this.categorydatatitle = res.data.category;
          this.categorydatalist = res.data.websiteList;
        }

        console.log('category',res)
    })
  },
  mounted(){

    document.querySelector('.ivu-anchor-ink-ball').style.top=8+'px';
  },
  methods:{
    // gotolabeldetails(){
    //   this.$router.push({
    //     name:'labeldetails'
    //   })
    // }
  }
};
</script>

<style lang="scss" scoped>
.mainbox{ padding-top: 60px;}
html,
body {
  height: 100%;
}
.leftbox {
  height: 100%;
  float: left;
  width: 230px;

  .leftboxmain {
    padding-left: 50px;
    padding-top: 30px;
    font-size: 15px;

    .backlist {
      padding-top: 10px;
      margin-top: 10px;
      padding-bottom: 20px; position: fixed;top:90px;cursor: pointer;
      span {
        border: 1px solid #f3f3f3;
        padding: 10px 20px;
        border-radius: 30px;
        font-size: 13px;
        line-height: 15px;
        i {
          padding-right: 10px;
          font-size: 16px;
          color: #999;
        }
      }
    }

    .zimubox {
      background: #f8f8f8;
      width: 40px;
      padding-top: 10px;
      padding-bottom: 10px;
      border-radius: 30px;
      font-size: 13px;
      margin-top: 15px;
    }
  }
}
.rightbox {
  width: 100%; min-height:673px;

  .rightmainbox {
    padding-left: 230px;

    .mianbaoxie{ padding-top: 15px;}

    ul.meitianul li {
      float: left;
      width: 22%;
      max-width: 355px;
      margin-right: 20px;
    }

    .dailyanlibox {
      overflow: hidden;
      h2 {
        font-size: 18px;
        padding-top: 30px;
        padding-bottom: 20px;
        font-weight: normal;
      }
      .dailylistbox {
        overflow: hidden;
        .alimgbox {
          img {
            max-width: 355px;
            max-height: 214px;
            width: 100%;
          }
        }
        .alimgname {
          padding-top: 8px;
          dl {
            dt {
              float: left;
              min-width: 50px;
              img {
                margin-left: 8px;
                margin-top: 8px;
              }
            }

            dd {
              float: left;
              width: 80%;
              h5 {
                font-size: 15px;
                font-weight: normal;
                color: #333;
              }
              p {
                color: #999;
                overflow: hidden;
                text-overflow: ellipsis;
                /*-webkit-text-overflow:ellipsis;*/
                white-space: nowrap;
              }
            }

            @media screen and (max-width: 1380px) {
              /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
              dd {
                float: left;
                width: 70%;
                h5 {
                  font-size: 15px;
                  font-weight: normal;
                  color: #333;
                }
                p {
                  color: #999;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  /*-webkit-text-overflow:ellipsis;*/
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
    }

    .fenleibiaoti {
      background: #f6f8f9;
      max-width: 1480px;
      width: 93.5%; margin-top: 20px;
      h3 {
        font-size: 20px; padding-left: 30px;
        padding-top: 20px;
      }
      h2 {
        font-size: 16px;
        padding-top: 15px; padding-left: 30px;
        padding-bottom: 25px; color: #999;
        font-weight: normal;
      }
    }

    .fenleimain {
      box-shadow: 0 0 3.5px #ddd; margin-top: 20px;
      max-width: 1480px;
      width: 93.5%;

      .indexcell {
        table {
          width: 100%;
          border-collapse: collapse;
          thead {
            background: #f6f8f9;
            line-height: 60px;
            b {
              display: inline-block;
              height: 15px;
              width: 3px;
              background: #505050;
            }
            span {
              font-size: 18px;
              margin-right: 10px;
              i {
                padding-left: 20px;
                font-size: 20px;
              }
            }
          }
          tbody {
            background: #fff;
            tr td {
              ul li {
                width: 25%;
                float: left;
                height: 95px;cursor: pointer;
                border: 1px solid #f3f3f9;
                border-left: none;
                border-top: none;
                
              }
              ul li:last-child {
              }
              ul li:first-child {
                border-left: none;
              }

              ul li:hover{}

              @media screen and (max-width: 1420px) {
                /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
                ul li {
                  width: 25%;
                }
              }
            }
          }
        }
      }
    }

    @media screen and (min-width: 1470px) and (max-width: 1840px) {
      .fenleimain {
        width: 92.5%;
      }
    }

    @media screen and (max-width: 1220px) {
      /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
      .fenleimain {
        width: 94%;
      }
    }
  }
}

.newword {
  display: inline-block;
  margin-left: 5px;
  width: 20px;
  line-height: 20px;
  background: #11be04;
  color: #fff;
  text-align: center;
}
.hotword {
  display: inline-block;
  margin-left: 5px;
  width: 20px;
  line-height: 20px;
  background: #ff0030;
  color: #fff;
  text-align: center;
}

.footerbox {
  height: 60px;
}

>>> .ivu-anchor-ink:before {
  background-color: #fff;
}
>>> .ivu-anchor-ink-ball {
  width: 18px;
  border-radius: 0;
  margin-top: 3px;
  background-color: #ffa200;
  border: 0 #fff solid;
  height: 3px;
  top: 8px;
  position: absolute;
}
.addwebbox {
  right: 30px;
  position: fixed;
  top: 38%;
}
@media screen and (max-width: 1300px) {  
  .addwebbox {
    right: 15px;
    position: fixed;
    top: 38%;
  }
}

>>> .ivu-anchor-link-active>.ivu-anchor-link-title{color: #ffa200;}
>>> .ivu-anchor-link >.ivu-anchor-link-title:hover{color: #ffa200;}

</style>



// WEBPACK FOOTER //
// src/components/pages/labellist.vue